import { NavLink } from 'react-router-dom';
import { FiHome, FiBriefcase, FiHeart, FiUser, FiSettings, FiPlusCircle, FiUsers, FiFileText, FiBarChart2 } from 'react-icons/fi';

const Sidebar = ({ isEmployer = false }) => {
  const jobSeekerLinks = [
    { to: '/dashboard', icon: FiHome, label: 'Dashboard' },
    { to: '/my-applications', icon: FiBriefcase, label: 'My Applications' },
    { to: '/saved-jobs', icon: FiHeart, label: 'Saved Jobs' },
    { to: '/profile', icon: FiUser, label: 'Profile' },
    { to: '/settings', icon: FiSettings, label: 'Settings' },
  ];

  const employerLinks = [
    { to: '/employer/dashboard', icon: FiHome, label: 'Dashboard' },
    { to: '/employer/post-job', icon: FiPlusCircle, label: 'Post a Job' },
    { to: '/employer/jobs', icon: FiBriefcase, label: 'Manage Jobs' },
    { to: '/employer/applications', icon: FiFileText, label: 'Applications' },
    { to: '/employer/company', icon: FiUsers, label: 'Company Profile' },
    { to: '/employer/analytics', icon: FiBarChart2, label: 'Analytics' },
    { to: '/settings', icon: FiSettings, label: 'Settings' },
  ];

  const links = isEmployer ? employerLinks : jobSeekerLinks;

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {links.map((link) => (
          <div className="nav-item" key={link.to}>
            <NavLink to={link.to} className="nav-link">
              <link.icon className="nav-icon" />
              <span>{link.label}</span>
            </NavLink>
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
